/**
 * Directive: transactionDisplay
 */
angular.module('acme.common.directive.transactionDisplay', [
    'acme.common.service.api'
])
.directive('transactionList', ['$compile', 'ApiService', function($compile, ApiService) {

    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'common/directives/transactionDisplay/transactionDisplay.tpl.html',
      scope: {
        transactionList: '=',
        settlementId: '@'
      },

      controller: ['$scope', function($scope) {

          $scope.transList = {

              selectedTransaction: null,

              toggleTransaction: function(id) {
                  // Check for the index
                  var elem  = null;

                  if ( this.selectedTransaction === id ) {
                      elem = angular.element('#trans' + id);
                      elem.remove();
                      this.selectedTransaction = null;
                  } else {
                      this.getDetail(id);
                  }
              },

              displayTransaction: function(id) {

                  var elem = angular.element('#' + id);

                  var html = '<tr id="trans' + id + '"><td colspan="9"><div data-ng-include="\'common/directives/transactionDisplay/transactionData.tpl.html\'"></div></td></tr>';
                  var el = angular.element($compile(html)($scope));

                  elem.after(el);

                  if ( this.selectedTransaction !== null ) {
                      elem = angular.element('#trans' + this.selectedTransaction);
                      elem.remove();
                  }

                  this.selectedTransaction = id;
              },

              getDetail: function(id) {
                  ApiService.settlements.transactions.get(id, $scope.settlementId).then(this.success.get, this.error.get);
              },

              success: {
                  get: function(response) {
                      $scope.transList.transaction = response.data.payload;
                      console.log("Transaction List: ", $scope.transList.transaction);
                      $scope.transList.displayTransaction($scope.transList.transaction.id);
                  }
              },

              error: {
                  get: function(response) {

                  }
              }
          };
      }]

    };
}]);